export default __webpack_public_path__ + "static/media/hall_of_fame_head.521b2f45.png";